const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
    <style>
    .banner-webinar {
        width: 100%;
        height: 370px;
        object-fit: cover;
    }
    .banner-label {
        background-color: #F96D01;
        position: absolute;
        padding: 10px 20px;
        border-radius: 0px 0px 0px 12px;
        font-size: 16px;
        color: #FFFFFF;
        top: 0;
        right: 0;
        opacity: 0.9;
    }
    .bg-live {
        background-color: #559808 !important;
    }
    .bg-finished {
        background-color: #424242
    }
    .banner-play {
        display: flex;
        width: 80px;
        height: 80px;
        border-radius: 40px;
        opacity: 1;
        background-color: rgba(0, 0, 0, 0.5);
        justify-content: center;
        align-items: center;
        position: absolute;
        margin: auto;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        cursor: pointer;
    }
    .banner-play img {
        width: 25.45px;
        height: 30.91px;
    }
    </style>
</template>`;
styleElement.register("banner-product-style");
